import Marquee from "react-fast-marquee";
import { CONTAINER, TRUST_DEFAULTS } from "@/components/home/data";
import { useBlock } from "@/lib/content";

export const TrustStrip = () => {
  const home = useBlock("home", null);
  const t = { ...TRUST_DEFAULTS, ...(home?.trust || {}) };
  const partners = Array.isArray(home?.trust?.partners) && home.trust.partners.length ? home.trust.partners : TRUST_DEFAULTS.partners;
  return (
  <section data-testid="trust-strip" className="border-y border-slate-200 bg-white py-8">
    <p className={`${CONTAINER} text-center font-cli text-[11px] uppercase tracking-[0.2em] text-slate-400 mb-6`}>
      {t.heading}
    </p>
    <Marquee gradient gradientColor="#ffffff" gradientWidth={80} speed={35} pauseOnHover>
      {partners.map((p, i) => (
        <span key={i} className="mx-8 font-heading text-xl font-medium text-slate-400 hover:text-slate-700 transition-colors">
          {p}
        </span>
      ))}
    </Marquee>
  </section>
  );
};
